import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FarmOverviewHouseViewComponent} from '../farm-overview-house-view/farm-overview-house-view.component';
import {
    FarmOverviewData,
    FarmAlertSummary,
    FarmHouse
} from '@/common/interface/farm-overview.data';

@Component({
    selector: 'app-farm-overview',
    standalone: true,
    imports: [CommonModule, FarmOverviewHouseViewComponent],
    templateUrl: './farm-overview.component.html',
    styleUrl: './farm-overview.component.scss'
})
export class FarmOverviewComponent {
    @Input() farm?: FarmOverviewData;
    @Input() alerts: FarmAlertSummary = {critical: 0, warning: 0, info: 0};
    @Input() houses: FarmHouse[] = [];
    expanded = true;

    toggleExpand(): void {
        this.expanded = !this.expanded;
    }
}
